export const habaUser = {
  habaCommonUserInformation: {
    nameAndJob: '{{firstName}} {{lastName}}, {{job}}',
    profileImageAlt: "Photo de profil de l'utilisateur",
    validation: {
      invalidName:
        'Veuillez vérifier que le nom que vous avez saisi ne contient pas de chiffres ou de symboles atypiques (%&$...).',
    },
  },
  habaLoginForm: {
    heading: 'Bienvenue à nouveau',
    forgotPassword: 'Mot de passe oublié?',
    signIn: "S'inscrire",
    register: "S'inscrire maintenant",
    dontHaveAccount: 'Pas encore de compte?',
    emailAddress: {
      label: 'Adresse e-mail',
      wrongEmailFormat: 'Veuillez saisir une adresse e-mail valide.',
    },
    password: {
      label: 'Mot de passe',
      passwordRequired: 'Veuillez saisir un mot de passe.',
    },
    guestCheckout: "Commander en tant qu'invité",
    successfulLogin: 'Soyez les bienvenus ! Connexion réussie',
  },
  habaRegisterForm: {
    heading: 'Créer un nouveau compte client',
    register: "S'inscrire maintenant",
    registerAsGuest: 'Continuer en tant que client invité',
    emailAddress: {
      label: 'Adresse e-mail',
      wrongEmailFormat: 'Veuillez saisir une adresse e-mail valide.',
    },
    password: {
      label: 'Mot de passe',
      passwordRequired:
        'Au moins 6 caractères, au moins un caractère spécial, au moins une lettre majuscule, au moins une lettre minuscule',
    },
    passwordRepeat: {
      label: 'Répéter le mot de passe',
      passwordRequired: 'Le mot de passe et la répétition du mot de passe ne correspondent pas.',
    },
    postRegisterMessage:
      "Veuillez confirmer votre adresse e-mail, puis nous pourrons créer votre compte.<br/>Nous vous avons envoyé un courriel. Cliquez simplement sur le lien de confirmation dans l'e-mail.",
    firstName: {
      label: 'Prénom',
      required: 'Champ obligatoire',
    },
    lastName: {
      label: 'Nom de famille',
      required: 'Champ obligatoire',
    },
    newsletter: "S'inscrire à la newsletter",
    privacy: {
      label: 'J\'accepte la <a href="{{url}}"><u>politique</u></a> de confidentialité.',
      required:
        'Veuillez confirmer que vous avez lu et accepté notre politique de confidentialité.',
    },
    checkoutRegister: {
      headline: 'Commander en tant que nouveau client/client invité',
      orderAsGuestTitle: "Commander en tant qu'invité ?",
      orderAsGuestText: "Oui, je souhaite commander en tant qu'invité",
    },
  },
  habaNavLogin: {
    login: "S'inscrire",
    register: "S'enregistrer",
    logoutLink: 'Se désinscrire',
    logout: 'Pas {{name}}?',
    successfulLogout: 'Déconnexion réussi',
    loginIncentiveText: 'Connecte-toi avec ton compte client et profite des offres du Family Club.',
    loginIncentiveTextHaba:
      "Connectez-vous à votre compte et bénéficiez d'un traitement plus rapide des commandes et d'offres spéciales.",
    modal: {
      headline: 'Mon compte',
      myProfile: 'Mon profil',
    },
    myAccount: {
      overview: 'Aperçu',
      orders: 'Commandes',
      accountData: 'Données des clients',
      deliveryAddresses: 'Adresses de livraison',
    },
  },
  habaForgottenPassword: {
    heading: {
      forgotPassword: 'Vous avez oublié votre mot de passe?  <br/> Pas de problème!',
      resetMailSend: 'On y est presque!',
      resetPassword: 'Attribuer un nouveau mot de passe',
    },
    infoText: {
      forgotPassword:
        "Veuillez utiliser l'adresse e- mail que vous avez utilisée pour enregistrer votre compte.<br/> Nous t'enverrons alors un lien que tu pourras utiliser pour créer un nouveau mot de passe.",
      resetMailSend: {
        firstPart: 'Nous avons envoyé un e-mail à <b>{{ emailAddress }}</b>.',
        secondPart: "Veuillez suivre le lien dans l'e-mail pour définir un nouveau mot de passe.",
      },
      noEmailInfo: {
        headline: 'Pas de message reçu ?',
        reason1: "Vérifiez si l'adresse e-mail est correcte",
        reason2: 'Vérifiez votre dossier de spam',
        newUser: 'Nouveau chez HABA ? Alors créez ',
        newUserLinkText: 'ici',
        yourAccount: ' votre compte client',
        backToAccount: 'Retour à la connexion',
      },
      resetPassword:
        'Pour que ton compte reste sécurisé, ton mot de passe doit contenir au moins les caractères suivants:',
    },
    emailAddress: {
      label: 'Adresse e- mail',
      wrongEmailFormat: 'Veuillez saisir une adresse e-mail valide.',
    },
    button: {
      submitResetPassword: 'Réinitialiser le mot de passe',
      backToLogin: "Retour à l'inscription",
      submitNewPassword: 'Attribuer un nouveau mot de passe',
    },
    errorMessage:
      "En raison de problèmes techniques, le processus de réinitialisation du mot de passe n'a pas pu être exécuté.Veuillez réessayer plus tard...",
    passwordChangeSuccess: {
      titre: 'Nouveau mot de passe attribué avec succès.',
      message: 'Connectez-vous maintenant avec votre nouveau mot de passe.',
      bouton: "À L'ENREGISTREMENT",
    },
  },
  habaProRegisterForm: {
    button: {
      submit: "S'inscrire maintenant",
    },
    form: {
      additionalAddressInfo: "Complément d'adresse",
      company: 'Entreprise',
      contactPerson: 'Personne de contact',
      country: 'Pays',
      firstName: 'Prénom',
      gtc: "J'accepte la déclaration de protection des données ainsi que les conditions générales. La loi vous accorde un droit de rétractation de 14 jours. Les détails et les exceptions à ce sujet figurent dans nos informations sur le droit de rétractation.",
      industry: 'Secteur',
      institution: 'Institution',
      lastName: 'Nom de famille',
      madam: 'Mme',
      optional: '(optionnel)',
      phone: 'Numéro de téléphone',
      sir: 'Monsieur',
      street: 'Rue',
      streetNumber: 'Numéro de rue',
      town: 'Ville',
      zip: 'Code postal',
    },
    formError: {
      gtc: 'Veuillez accepter les conditions générales.',
      phoneNumberFormat: 'Veuillez utiliser le format: +3312345678',
      zipCodeLength: 'Le code postal doit comporter {{length}} chiffres.',
    },
    messages: {
      registeredSuccessfully: 'Enregistré avec succès.',
      userAlreadyExists: 'Utilisateur existe déjà.',
    },
  },
  habaAccountOverview: {
    personalProfile: 'Profil personnel',
    personalProfileMessage:
      "C'est ton profil personnel {{storeName}}, tu y trouveras toutes les informations importantes et une foule d'inspirations !",
    pageTitle: 'Bienvenue dans votre compte client',
    pageDescription: 'lorem ipsum set delor',
    card: {
      orders: {
        title: 'Mes commandes',
        text: '',
        btnText: "Vers l'aperçu des commandes",
      },
      wishlist: {
        title: "Liste d'envies",
        text: '',
        btnText: 'Vers la liste de souhaits',
      },
      customerData: {
        title: 'Mes données client',
        text: '',
        btnText: 'Vers mes données',
      },
      delivery: {
        title: 'Mes adresses de livraison',
        text: '',
        btnText: 'Vers les adresses de livraison',
      },
    },
  },
  habaCustomerData: {
    loginData: {
      changeEmailAndSave: "Modifier & enregistrer l'adresse e-mail",
      changeLoginData: 'Modifier les données de connexion',
      changePasswordAndSave: 'Modifier & enregistrer le mot de passe',
      confirmNewEmail: 'Confirmer la nouvelle adresse e-mail',
      confirmNewPassword: 'Confirmer le nouveau mot de passe',
      currentEmail: 'Adresse e- mail actuelle:',
      currentPassword: 'Mot de passe actuel',
      currentPasswordRequired: 'Veuillez saisir votre mot de passe actuel.',
      emailsMustMatch: 'Les adresses e-mail doivent correspondre',
      invalidEmail: 'Veuillez saisir une adresse e-mail valide',
      newEmail: 'Nouvelle adresse e-mail',
      newPassword: 'Nouveau mot de passe',
    },
    deliveryAddress: {
      addDeliveryAddress: 'Ajouter une adresse de livraison',
      defaultDeliveryAddress: 'Adresse de livraison par défaut',
      delete: 'Supprimer',
      deleteDeliveryAddress: "Supprimer l'adresse de livraison?",
      deliveryAddresses: 'Adresses de livraison',
      edit: 'Modifier',
      newDeliveryAddress: 'Ajouter une adresse de livraison',
      pendingOrders: 'Les commandes en attente envoyées à cette adresse ne seront pas annulées.',
      phoneNumber: 'Numéro de tél.',
      updateDeliveryAddress: "Actualiser l'adresse de livraison",
    },
    overview: {
      address: 'Adresse',
      billingAddress: 'Adresse de facturation',
      emailAddress: 'Adresse e-mail',
      loginData: 'Données de login',
      myData: 'Mes données',
      name: 'Nom',
      noBillingAddress: "Vous n'avez pas encore d'adresse de facturation.",
      password: 'Mot de passe',
      personalData: 'Données personnelles',
      phoneNumber: 'Numéro de téléphone',
    },
    childrenData: {
      createNew: {
        btn: 'Ajouter un enfant',
        heading1: "Nouvel enfant à l'anniversaire",
        heading2: 'Pourquoi souhaitons-nous connaître les membres de ta famille?',
        desc1:
          "Jusqu'à présent, vous n'avez pas encore ajouté d'anniversaire pour votre enfant. <br/>Ajoutez-en un tout de suite",
        desc2:
          "Nous aimerions connaître les membres de ta famille afin de pouvoir t'envoyer des offres et des cadeaux personnalisés",
        Privacy:
          "Tu peux à tout moment t'opposer à l'utilisation de tes données à des fins publicitaires. Tu trouveras plus d'informations dans la politique de confidentialité.",
        option1: "Cadeau d'anniversaire",
        option2: 'Offres sur mesure',
        option3: "Encore plus d'avantages",
        optDesc1: `Pour l'anniversaire de ton enfant, exclusivement pour les abonnés à la newsletter. <a href="{{url}}"><u>Inscrivez-vous ici.</u></a>`,
        optDesc2: 'Offres individuelles spécialement conçues pour ta famille. <br/> <br/>',
        optDesc3:
          "HABA accompagne les familles de la grossesse à l'adolescence en passant par la naissance.",
        addressLimit: 'Vous avez atteint le maximum de 10 enfants.',
        addressLimitText:
          "Si vous souhaitez ajouter un nouvel enfant à son anniversaire, vous devez supprimer l'un des anniversaires ajoutés.",
        successMessage: 'Un nouveau jour de naissance a été créé.',
        errorMessage: "Quelque chose s'est mal passé. Veuillez réessayer.",
        birthDateMonthsMessage: 'Plus que <b>{{number}} mois<b/>',
        birthDateMonthMessage: 'Plus que <b>{{number}} mois<b/>',
        birthDateDaysMessage: 'Plus que <b>{{number}} jours<b/>',
        birthDateDayMessage: 'Encore <b>{{number}} jours<b/>',
        todayIsBirthDay: `<b>aujourd'hui<b/>`,
        tomorrowIsBirthDay: '<b>Demain<b/>',
      },
      edit: {
        heading1: '',
        desc1:
          "Saisissez la date de naissance de votre enfant. Si vous avez plusieurs enfants, vous pouvez ajouter un anniversaire pour chacun.<br> Vous pouvez ajouter jusqu'à 10 anniversaires.",
        cardHeading: 'Votre enfant est-il déjà né ?',
        option1: 'Enfant déjà né',
        option2: 'Date de naissance estimée pour les femmes enceintes',
        gender: 'Genre',
        name: 'Quel est le nom de votre enfant ?',
        unBornNameLabel: 'As-tu pensé à un nom pour le futur enfant ?',
        noGenderLabel: 'Je ne sais pas encore',
        dob: 'Date de naissance',
        dayOfBirth: 'Anniversaire',
        kind: 'Enfant ',
        mainSection: 'Les données de mes enfants',
        boy: 'garçon',
        girl: 'Fille',
        divers: 'Divers',
        pregnant: 'Enceinte',
        day: 'jour',
        month: 'mois',
        year: 'année',
        pastDateError: 'La date devrait être dans le passé',
        futureDateError: 'La date devrait être dans le futur',
      },
      delete: {
        title: "Supprimer l'anniversaire",
        desc: "Möchten Sie den ausgewählten Geburtstag wirklich löschen? Une fois supprimé, il <br/> n'apparaîtra plus dans vos options <br/> d'anniversaire.",
        btnText: "Supprimer l'anniversaire",
        successMessage: 'Date de naissance supprimée avec succès',
      },
    },
    invoiceDownload: {
      headline: 'Demande de facture',
      secondHeadline:
        "Vous n'avez plus la facture sous la main et vous avez besoin d'une copie de la facture ? ",
      descriptionPart1:
        'Il suffit de la télécharger ici. Saisissez votre numéro de client et votre numéro de facture dans les champs de saisie suivants et cliquez sur Télécharger.',
      descriptionPart2:
        "Pour des raisons de protection des données, le système vérifie en arrière-plan si le numéro de client et le numéro de facture sont compatibles - ce n'est que dans ce cas que le téléchargement est possible.",
      descriptionPart3:
        "Vous ne pouvez télécharger qu'une seule facture à la fois. Si vous avez plusieurs factures, vous devez suivre ces étapes l'une après l'autre.",
      inputCustomerNr: 'Numéro de client',
      inputInvoiceNr: 'Numéro de la facture',
      inputCustomerNrError: 'Le numéro de client doit être indiqué.',
      inputInvoiceNrError: 'Le numéro de la facture doit être indiqué.',
      submitButton: 'Télécharger la facture',
      notFound:
        "Une facture pour le numéro de client et le numéro de facture spécifiés n'a pas pu être trouvée.",
    },
  },
  habaOrderHistory: {
    loading: 'Chargement des données...',
    empty: {
      noOrder:
        "Jusqu'à présent, vous n'avez passé aucune commande dans notre boutique en ligne. Jetez un coup d'œil maintenant et explorez notre large gamme de produits...",
    },
    headline: 'Mes commandes',
    orderItem: {
      headline: {
        prefix: 'Ordre de',
      },
      details: {
        orderNumber: 'Numéro de commande',
        orderValue: 'Total',
      },
      button: "Voir l'ordre",
    },
    detailView: {
      headline: 'Commande',
      backLink: 'Aperçu des commandes',
      label: {
        orderDate: 'Date de commande',
        shippingMethod: "Mode d'expédition",
        deliveryAddress: 'Adresse de livraison',
        paymentAddress: 'Adresse de facturation',
        paymentMethod: 'Méthode de paiement',
        orderTotal: 'Somme totale',
        totalTax: 'TVA incluse {{percentFormatted}}',
        deliveryCosts: "Frais d'expédition",
        discounts: 'remise incluse',
        articleValue: 'Total articles',
        order: 'Votre commande',
        status: 'Statut',
        tracking: 'Suivi des envois',
        numberOfShipments: "Nombre d'envois",
        shipmentStatus: "Statut de l'envoi",
        shipments: 'Envoi {{number}} de {{total}}',
        canceledArticles: 'Articles annulés',
        totalGiftCardAmount: 'Valeur du bon encaissée',
      },
      entries: {
        quantity: 'Quantité: {{quantity}}',
        color: 'Couleur:',
        size: 'Größe:',
      },
    },
  },
  myAccountSectionData: {
    standardShippingAddress: 'Ceci est votre <b> adresse de livraison par défaut  <b/>',
    standardBillingAddress: 'Ceci est ton <b> adresse de facturation par défaut <b />',
    makeStandardShippingAddress: 'Définir comme <b>adresse de livraison par défaut <b/>.',
    makeStandardBillingAddress: "Définir <b>l'adresse de facturation par défaut <b/>.",
    editNewAddressHeadline: "Modifier l'adresse",
    editNewAddressSubHeadline:
      'Veuillez saisir une adresse que vous enregistrez et à laquelle vous souhaitez livrer vos articles',
    newAddressHeadline: 'Ajouter une nouvelle adresse',
    noAddressHeadline: 'Aucune adresse ajoutée',
    noAddressText:
      "Vous n'avez pas encore ajouté d'adresse pour vous-même.<br/>Ajouter une adresse maintenant",
    personalData: 'Quelles sont vos données personnelles ?',
    deleteHeadline: "Supprimer l'adresse",
    disableDeleteBtnText:
      "Cette adresse ne peut pas être supprimée tant qu'elle est définie comme adresse de livraison et de facturation par défaut. Pour supprimer l'adresse, il faut sélectionner une autre adresse comme adresse standard. <br/><br/> Actuellement, il n'y a qu'une seule adresse. Ajoute une <b> nouvelle adresse <b /> pour modifier l'adresse par défaut.",
    deleteTextInfo:
      "Voulez-vous vraiment supprimer l'adresse sélectionnée?<br/>Une fois supprimée, elle n'apparaîtra plus dans vos options d'adresses de livraison et de facturation",
    tooltipBilling:
      "Bei einer Bestellung wird diese Adresse standardmäßig auf dem Rechnungsdokument angezeigt. L'adresse peut également être modifiée en cours de commande.<br/><br/> Vous n'avez actuellement ajouté qu'une seule adresse. Pour modifier l'adresse de facturation par défaut, vous devez ajouter une <b>nouvelle adresse.<b />",
    tooltipShipping:
      'Cette adresse est définie comme adresse de livraison principale pour le contrôle des commandes. Vous pouvez la modifier en sélectionnant une autre de vos adresses.',
    tooltipCountrySelection:
      "L'expédition n'est possible que dans la version nationale sélectionnée de la boutique en ligne. Le pays peut être modifié en bas de la page. <br/> L'adresse de livraison peut également être facilement ajoutée ou modifiée lors de la commande. N'importe quelle adresse peut être utilisée comme adresse de facturation, quel que soit le pays.",
    tooltipCancelBtn:
      "Vous ne pouvez pas supprimer cette adresse tant qu'elle est définie comme adresse de facturation ou de livraison. Après avoir sélectionné une adresse différente de votre adresse principale, vous pouvez la supprimer. <br /> <br/> Actuellement, vous avez ajouté une adresse. Um die Haupt Lieferadresse zu ändern, müssen Sie also eine <b>neue Adresse hinzufügen.<b />",
  },
  habaPasswordRules: {
    signLength: '6 caractères',
    specialChar: 'un caractère spécial',
    charUppercase: 'une lettre majuscule',
    charLowercase: 'une lettre minuscule',
  },
};
